<template>
<div class="list">
  <div class="breadcrumb">
    <Breadcrumb>
      <Breadcrumb-item href="#">官网活动</Breadcrumb-item>
      <Breadcrumb-item>学生作品管理</Breadcrumb-item>
    </Breadcrumb>
  </div>
  <div class="search" @keyup.enter="search">
    <Form :label-width="100" :show-message="false" label-position="right">
      <Row :gutter="32">
        <Col :span="6">
          <Form-item label="学生ID">
            <Input name="userId" v-model="queryParam.userId"/>
          </Form-item>
        </Col>
        <Col :span="6">
          <Form-item label="手机号后六位">
            <Input name="cardId" v-model="queryParam.cardId"/>
          </Form-item>
        </Col>
        <Col :span="6">
          <Form-item label="学生姓名">
            <Input name="nickname" v-model="queryParam.nickname"/>
          </Form-item>
        </Col>
        <Col :span="6">
          <Form-item label="作品名称">
            <Input name="title" v-model="queryParam.title"/>
          </Form-item>
        </Col>
        <Col :span="6">
        <Form-item label="所属赛区">
          <Select v-model.number="queryParam.competitionArea" placeholder="请选择" clearable>
            <Option v-for="item in $constant.competitionAreaEnum" :key="item.code" :value="item.code">{{item.text}}</Option>
          </Select>
        </Form-item>
        </Col>
        <Col :span="6">
          <Form-item label="年龄分组">
            <Select v-model.number="queryParam.ageGroup" placeholder="请选择" clearable>
              <Option v-for="item in $constant.ageGroupEnum" :key="item.code" :value="item.code">{{item.text}}</Option>
            </Select>
          </Form-item>
        </Col>
        <Col>
          <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search" @click="search">搜索</Button>
        </Col>
      </Row>
      <Row type="flex" justify="end">
        <Col>
          <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="goNextPhase" @click="goNextPhase">进入下一阶段</Button>
        </Col>
      </Row>
    </Form>
  </div>
  <List ref="dataList" :tableColumns="title" :reload="reload" listUrl="/safenessUserVideo/pageList" :params="queryParam" :onLoading="onLoading"  @on-selection-change="selectionChange"></List>
  <EditUserVideoModal :value="showEditUserVideoModal" :itemId="itemId" @on-close="showEditUserVideoModal = false" @on-edit-clearid="clearid" :successCallback="search"></EditUserVideoModal>
</div>
</template>

<style>
  .none{display:none}
</style>
<script>
  import EditUserVideoModal from './modal/EditUserVideoModal'
  export default {
    name: 'UserVideoList',
    components: {EditUserVideoModal},
    data () {
      let $constant = this.$constant
      return {
        searchLoading: false,
        reload: 0,
        selectionRecords: [],
        queryParam: {
          uid: null,
          title: '',
          userName: '',
          mobile: '',
          competitionArea: null,
          ageGroup: null
        },
        itemId: null,
        showAddUserVideoModal: false,
        showEditUserVideoModal: false,
        columnShow: false,
        title: [
          {
            type: 'selection',
            width: 40,
            align: 'center'
          },
          {
            title: '作品编号',
            width: 100,
            align: 'center',
            key: 'id'
          },
          {
            title: '学生ID',
            width: 80,
            align: 'center',
            key: 'userId'
          },
          {
            title: '学生姓名',
            width: 95,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              return h('span', row.userName)
            }
          },
          {
            title: '家长姓名',
            width: 95,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              return h('span', row.parentName)
            }
          },
          {
            title: '手机号后六位',
            width: 125,
            align: 'center',
            key: 'cardId'
          },
          {
            title: '作品名称',
            width: 150,
            align: 'center',
            key: 'title'
          },
          {
            title: '作品封面',
            width: 180,
            align: 'center',
            key: 'videoCover',
            render: (h, params) => {
              let row = params.row
              if (row.videoCover) {
                return h('a', {domProps: {title: '点击预览'}, on: {click: () => this.showIndex(row.videoCover)}}, row.videoCover)
              } else {
                return h('span')
              }
            }
          },
          {
            title: '作品',
            width: 180,
            align: 'center',
            key: 'videoCover',
            render: (h, params) => {
              let row = params.row
              if (row.videoUrl) {
                return h('a', {domProps: {title: '点击预览'}, on: {click: () => this.showIndex(row.videoUrl)}}, row.videoUrl)
              } else {
                return h('span')
              }
            }
          },
          {
            title: '所属赛区',
            width: 95,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              let competitionArea = row.competitionArea
              let competitionAreaEnum = $constant.getEnum($constant.competitionAreaEnum, competitionArea)
              return h('span', competitionAreaEnum && competitionAreaEnum.text)
            }
          },
          {
            title: '所属分组',
            width: 95,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              let ageGroup = row.ageGroup
              let ageGroupEnum = $constant.getEnum($constant.ageGroupEnum, ageGroup)
              return h('span', ageGroupEnum && ageGroupEnum.text)
            }
          },
          {
            title: '票数',
            width: 80,
            align: 'center',
            key: 'voteCount'
          },
          {
            title: '评分',
            width: 80,
            align: 'center',
            key: 'score'
          },
          {
            title: '比赛阶段',
            width: 100,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              let phase = row.phase
              let phaseEnum = $constant.getEnum($constant.phaseEnum, phase)
              return h('span', phaseEnum && phaseEnum.text)
            }
          },
          {
            title: '审核状态',
            width: 100,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              let status = row.status
              let statusEnum = $constant.getEnum($constant.auditStatus, status)
              return h('span', statusEnum && statusEnum.text)
            }
          },
          {
            title: '操作',
            width: 120,
            align: 'center',
            render: (h, params) => {
              let self = this
              let row = params.row
              let status = row.status
              return h('span', [
                h('a', {on: {click: () => self.onEdit(row)}}, '编辑'),
                h('span', ' | '),
                h('a', {on: {click: () => self.auditVideo(row.id, status === 1 ? 2 : 1)}}, status === 1 ? '不通过' : '通过')
              ])
            }
          }
        ]
      }
    },
    methods: {
      showIndex (videoPicUrl) {
        if (videoPicUrl) {
          window.open('http://medias.kouyujie.cn/' + videoPicUrl + '?' + Date.parse(new Date()))
        }
      },
      search () {
        this.reload = new Date().getTime()
      },
      selectionChange (selection) {
        this.selectionRecords = selection
      },
      onAdd () {
        this.showAddUserVideoModal = true
      },
      onLoading (loading) {
        this.searchLoading = loading
      },
      clearid () {
        this.itemId = null
      },
      onEdit (row) {
        this.showEditUserVideoModal = true
        this.itemId = row.id
      },
      showVideo (row) {
        let videoUrl = row.videoUrl
        if (videoUrl) {
          window.open('http://medias.kouyujie.cn/' + videoUrl + '?' + Date.parse(new Date()))
        }
      },
      auditVideo (id, auditStatus) {
        let self = this
        self.$Modal.confirm({
          title: '提示',
          content: auditStatus === 1 ? '是否 <b>通过</b> 此作品？' : '是否 <b>不通过</b> 此作品？',
          width: 300,
          okText: auditStatus === 1 ? '确定通过' : '确定不通过',
          loading: true,
          onOk: () => {
            self.$http.post('/safenessUserVideo/check', {id: id, status: auditStatus}).then(function (resp) {
              self.search()
              self.$Message.success('操作成功!')
              self.$Modal.remove()
            })
          }
        })
      },
      goNextPhase () {
        let self = this
        self.$Modal.confirm({
          title: '提示',
          content: '确定进入下一阶段？',
          width: 300,
          okText: '确定',
          loading: true,
          onOk: () => {
            let userIds = []
            if (this.selectionRecords && this.selectionRecords.length > 0) {
              for (let i in this.selectionRecords) {
                let userVideo = this.selectionRecords[i]
                userIds[i] = userVideo.userId
              }
            }
            self.$http.post('/safenessUserVideo/goNextPhase', {ids: userIds.join(',')}).then(function (resp) {
              if (resp && resp.status === 'ok') {
                self.$Message.success('批量操作成功！')
                self.cancelLoading = false
                self.search()
              } else {
                self.$Message.error('批量操作失败！')
                self.cancelLoading = false
              }
            }).catch((e) => {
              this.cancelLoading = false
            })
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// UserVideoList.vue?279177dc